import React, { useEffect, useState } from 'react'
import { useAnimation, motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

import { FaGreaterThan, FaLessThan } from 'react-icons/fa'

import { Button, chakra, useColorModeValue, Box } from '@chakra-ui/react'
import { TestimonialItems } from './testimonial/TestimonialItems'
import { testimonialConstants } from '@/lib/constants/testimonialConstants'
import { moveUp } from '@/lib/animations'

export const Testimonial = () => {
  const controls = useAnimation()
  const { inView, ref } = useInView()

  useEffect(() => {
    if (inView) {
      controls.start('visible')
    }
  }, [controls, inView])

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }: any) => {
    const {
      carouselState: { currentSlide },
    } = rest
    return (
      <>
        <Button
          bgColor="secondaryLighter"
          rounded="full"
          fontSize="1rem"
          color="primary"
          onClick={() => previous()}
          disabled={currentSlide === 0 ? true : false}
        >
          <FaLessThan />
        </Button>

        <Button
          bgColor="secondaryLighter"
          rounded="full"
          fontSize="1rem"
          color="primary"
          onClick={() => next()}
          disabled={currentSlide === 0 ? true : false}
        >
          <FaGreaterThan />
        </Button>
      </>
    )
  }

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2.5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 700 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 699, min: 0 },
      items: 1,
    },
  }
  const bgColor = useColorModeValue('lightGray', 'lightBlack')
  return (
    <chakra.section w="full" mb="7rem" mt="7rem" id="testimonials" p="2rem">
      <Box
        maxW="74rem"
        p="2rem 0"
        bg={bgColor}
        borderRadius="41px"
        alignItems="center"
        justifyContent="center"
        py={8}
        mx="auto"
        as={motion.div}
        animate={controls}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={moveUp}
        overflow={'hidden'}
      >
        {/* @ts-ignore */}
        <Carousel
          responsive={responsive}
          autoPlay={true}
          autoPlaySpeed={2000}
          infinite={true}
          customButtonGroup={<ButtonGroup />}
        >
          {testimonialConstants.map(testmo => (
            <TestimonialItems
              key={testmo.id}
              id={testmo.id}
              pics={testmo.pics}
              comment={testmo.comment}
              title={testmo.title}
            />
          ))}
        </Carousel>
      </Box>
    </chakra.section>
  )
}
